export const GET_FEATURE_FLAGS = 'GET_FEATURE_FLAGS';
export const FEATURE_FLAGS_ERROR = 'FEATURE_FLAGS_ERROR';
export const FEATURE_FLAGS_GETUSERGROUP = 'FEATURE_FLAGS_GETUSERGROUP';
export const FEATURE_FLAGS_INITIALISED = 'FEATURE_FLAGS_INITIALISED'
